export type MediaAttachmentStatus = 'uploading' | 'success' | 'error';

export enum MediaErrorCode {
  UploadFailed = 'UPLOAD_FAILED',
}

export interface MediaAttachment {
  id: string;
  fieldKey: string;
  file: File;
  previewUrl?: string;
  status: MediaAttachmentStatus;
  mediaId?: string;
  errorCode?: MediaErrorCode;
  message?: string;
}

/** Per-input validation rules. Controlled at each field/input level. */
export interface MediaValidationRules {
  /** Allowed MIME types or extensions, e.g. ['image/*', 'application/pdf', '.png']. Empty/undefined = allow all. */
  accept?: string[];
  maxSizeBytes?: number;
  maxFiles?: number;
  minFiles?: number;
  required?: boolean;
}

export interface MediaValidationResult {
  valid: boolean;
  errorCode?: MediaErrorCode;
  message?: string;
}

export interface MediaFieldUploadStatus {
  count: number;
  successCount: number;
  isUploading: boolean;
  hasError: boolean;
}
